<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/solutions/digitalinfrastructure"
                  >Digital Infrastructure</router-link
                >
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Collaboration
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Collaboration</h2>

              <p class="lead">
                In a world of digital technologies, businesses strive to support
                personal collaboration with important tools like email, instant
                messaging and texting. However, complex human interaction
                demands more than just voice to voice which can communicate to a
                personal experience. In a bid to step up your communication
                system, it requires expertise and professionals grounded in
                voice, messaging, online collaboration and video technologies to
                ensure efficiency and increase your business ROI.
              </p>
              <p class="lead">
                We connect businesses and customers face-to-face from any web
                connection with vital information that speeds up project
                completion and is cost-effective. Our personalized collaboration
                may include
              </p>

              <h3 class="">Voice</h3>
              <p class="lead">
                We help you deploy voice calling solutions that leverage the
                cloud-based infrastructure.
              </p>
              <h3 class="">Corporation Video</h3>
              <p class="lead">
                Speeds up face to face collaboration that improves productivity
              </p>  
              <h3 class="">Instant messaging</h3>
              <p class="lead">Quickly communicate and share ideas.</p>
              <h3 class="">Conference seminars and discussions</h3>
              <p class="lead">
                Connecting face to face in real-time, bringing prospects into a
                room ensuring collaboration.
              </p>
              <h3 class="">Contact center</h3>
              <p class="lead">
                Gives a more unique and personal experience with customers from
                simple phone transactions to meet their individual needs.
              </p>

           <h3 class="">Audio-visual</h3>
              <p class="lead">
               Optimizes and offers a realistic experience to enhance productivity.
              </p>



            </div>

            <div class="col-lg-4">
              <DigitalInfraSideNav></DigitalInfraSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import DigitalInfraSideNav from "./DigitalInfraSideNav";
export default {
  name: "collaboration",
  components: {
    DigitalInfraSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
